


export const generalRouteTitles = {
    "": "Code in Place",
    "terms-of-service": "Code in Place Terms of Service",
    "ai-policy": "Code in Place X AI Policy",
    "team": "Code in Place Team",
    "showcase": "Code in Place Project Showcase",
    "emailactionhandler": "Code in Place Email Action",
    "welcome": "Welcome to Code in Place",
    "give": "Support Code in Place",
    "unsubscribe": "Email Management Page",
    "delete-my-account": "Delete Account",
    "loadingtest": "Loading Test Page",
    "delete-whatsapp-data": "Delete WhatsApp Data",
    "interest" : "Code in Place Interest Form",
    "oauth2": "Code in Place OAuth2 Redirect",
    "contact": "Code in Place Contact Us",
    "404": "Page Not Found - 404",
    "noaccess": "No Access",
    "error": "Error",
    "error-boundary": "Error",
    "wait-standard": "Please Wait",
    "wait-live": "Please Wait"
}


export const courseRouteTitles = {
    "review": {
        "stats": "Review Statistics",
        "calibration": "Review Calibration",
        "app": "Review Application",
        "": "Review Dashboard"
    },
    "onbording": {
        "student": {
            "": "Student Onboarding",
            "accommodations": "Student Accommodations",
            "schedule": "Section Schedule Setup",
            "profile": "Student Profile Setup",
        },
        "sl" : {
            "": "Teaching Onboarding",
            "profile": "Teaching Profile Setup",
            "schedule": "Teaching Schedule Setup",
            "volunteeragreement": "Volunteer Agreement",
            "smallGroup": "Small Group Setup",
            "referfriend": "Refer a Friend",
        },
        "experiencedstudent": {
            "": "Experienced Student Onboarding",
            "profile": "Experienced Student Profile Setup",
            "commiting": "Commitment Form",
            "sectionproposal": "Experienced Student Section Time Proposal",
        },
        "mentor": {
            "": "Mentor Onboarding",
            "profile": "Mentor Profile Setup",
            "volunteeragreement": "Volunteer Agreement",
            "sectionproposal": "Mentor Section Time Proposal",
        },
    },
    "certificate": "Code in Place Certificate",
    "diagnostic": "Code in Place Diagnostic",
    "week1-update": "Week 1 Update",
    "week3-update": "Week 3 Update",

}